
import { HttpClient } from "./http";

class User extends HttpClient {
    constructor() {
        super();
    }

    profile() {
        return this.HTTP.get('/auth/user-profile')
    }
}

export const UserService = new User();
